<template>
<div>
  <div class="levo__dole">
    
      <LevoHowTo text="How to play"  @leave="openModalHowTo" />
    <LevoLeave text="Leave the game" @leave="openModal" />

    <Modal ref="modalRef" width="450px">
      <div class="modal__questionHeader">
        Do you really want to leave the game?
      </div>
      <div class="clearfix">
        <button class="modal__approve" @click="leaveGame">Yes</button>
        <div class="modal__cancel" @click="closeModal">No</div>
      </div>
    </Modal>
    <ModalHowTo ref="modalRefHow" width="450px">
      <div class="modal__questionHeader">
        Tutorials
      </div>
      <div class="clearfix">
        <a href="https://vimeo.com/664261088/e8ff4278b0" target="_blank">
          <div class="login__videos__video__button">
             Registration and joining a game
          </div>
        </a>
        <a href="https://vimeo.com/664261114/59f83f689a" target="_blank">
          <div class="login__videos__video__button">
             How to play 
          </div>
        </a>
        <a href="https://vimeo.com/664261179/9878514058" target="_blank">
          <div class="login__videos__video__button">
             Tips & tricks 
          </div>
        </a>
      </div>
    </ModalHowTo>
    </div>
  </div>
</template>

<script>
import ModalHowTo from "@/components/general/ModalHowTo.vue";
import ModalHowtojs from "@/components/general/ModalHowTo.js";
import ModalJs from "@/components/general/ModalJs.js";
import LevoLeave from "@/components/general/LevoLeave.vue";
import LevoHowTo from "@/components/general/LevoHowTo.vue";

import { mapActions } from "vuex";

export default {
  name: "LevoDole",
  mixins: [ModalJs, ModalHowtojs],
  components: {
    LevoLeave,
    LevoHowTo,
    ModalHowTo
  },
  methods: {
    ...mapActions(["toggleLoader"]),
    async leaveGame() {
      await this.toggleLoader(true);
      await this.$router.push({ name: "Join" });
      await this.toggleLoader(false);
    },
  },
};
</script>
